import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { buildFleetQuery } from '../_shared/utils/fleet-query';

@Injectable({
  providedIn: 'root'
})
export class FleetGeneralInsightsService {

  constructor(private readonly httpClient: HttpClient) { }

  getFleetStatus(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'status-fleet?' + buildFleetQuery(fleetId, batteryType));
  }

  getBatteryTypes(fleetId: string): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'battery-type/' + encodeURIComponent(fleetId));
  }
}
